import { __awaiter, __generator, __values } from "tslib";
import { Fetch } from '@ekuaibao/fetch';
import { dynamicImportTranslatePlugin } from '../lib/i18n';
export function i18nHelper(str) {
    return function (args) {
        var e_1, _a;
        var i18nStr = str;
        try {
            for (var _b = __values(Object.keys(args)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var reg = new RegExp("{" + key + "}", 'g');
                var replaceValue = String(args[key]);
                i18nStr = i18nStr.replace(reg, replaceValue);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return i18nStr;
    };
}
export function enableSettingTranslate() {
    return __awaiter(this, void 0, void 0, function () {
        var target, LanguagesIgnoreByTranslatePlugin, translateConfig, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    target = getLanguageByLanguageCode(Fetch.defaultLanguage);
                    LanguagesIgnoreByTranslatePlugin = ['zh-CN', 'en-US'];
                    if (LanguagesIgnoreByTranslatePlugin.includes(target)) {
                        return [2];
                    }
                    return [4, dynamicImportTranslatePlugin()];
                case 1:
                    _a.sent();
                    translateConfig = window.TranslateConfig;
                    if (translateConfig) {
                        translateConfig.initTranslate();
                        translateConfig.setToLanguage(target);
                    }
                    return [3, 3];
                case 2:
                    e_2 = _a.sent();
                    console.log(e_2);
                    return [3, 3];
                case 3: return [2];
            }
        });
    });
}
export var getLanguageByLanguageCode = function (code) {
    var _a;
    var languageOptions = [
        { code: 'zh-CN', label: '中文', icon: '', id: 'zh-CN' },
        { code: 'en-US', label: 'English', icon: '', id: 'en-US' },
        { code: 'ja-JP', label: '日本語', icon: '', id: 'japanese' },
        { code: 'ko-KR', label: '한국의', icon: '', id: 'korean' },
        { code: 'fr-FR', label: 'Français', icon: '', id: 'french' },
        { code: 'de-DE', label: 'Deutsch', icon: '', id: 'deutsch' },
        { code: 'es-ES', label: 'Español', icon: '', id: 'spanish' },
        { code: 'it-IT', label: 'Italiano', icon: '', id: 'italian' },
        { code: 'pt-PT', label: 'Protuguês', icon: '', id: 'portuguese' },
        { code: 'ms-MY', label: 'Bahasa Melayu', icon: '', id: 'malay' },
        { code: 'ru-RU', label: 'Русский', icon: '', id: 'russian' },
        { code: 'bn-BD', label: 'বাংলা', icon: '', id: 'bengali' },
        { code: 'hi-IN', label: 'हिंदी', icon: '', id: 'hindi' },
        { code: 'ar-IL', label: 'العربية', icon: '', id: 'arabic' },
        { code: 'th-TH', label: 'ไทย', icon: '', id: 'thai' },
        { code: 'tr-TR', label: 'Türkçe', icon: '', id: 'turkish' },
        { code: 'vi-VN', label: 'tiếng việt', icon: '', id: 'vietnamese' }
    ];
    return ((_a = languageOptions.find(function (item) { return item.code === code; })) === null || _a === void 0 ? void 0 : _a.id) || 'zh-CN';
};
